/*
* @Author: abhi714
* @Date:   2024-08-23 16:55:54
* @Last Modified by:   babysoft
* @Last Modified time: 2024-09-13 16:38:58
*/
import axios from 'axios';
import {API_URL} from '../settings/common.js';

class WAServices {
	async login(data){
		const url = `${API_URL}login`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async sendOtp(data){
		const url = `${API_URL}send-otp`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async signup(data){
		const url = `${API_URL}signup`;
		const headers = {
			'Content-Type': 'application/json'
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async updateProfile(auth_token,data=null){
		const url = `${API_URL}update-profile`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async getUserChat(auth_token,data=null){
		const url = `${API_URL}get-user-chat`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async getUserList(auth_token,data=null){
		const url = `${API_URL}get-user-list`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async sendMessage(auth_token,data=null){
		const url = `${API_URL}send-message`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async getConfiguration(auth_token){
		const url = `${API_URL}get-configuration`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		return axios({
			url:url,
			method: 'POST',
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async setConfiguration(auth_token,data=null){
		const url = `${API_URL}configure-setting`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async updateUserData(auth_token,data=null){
		const url = `${API_URL}update-user-data`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async addComment(auth_token,data) {
		const url = `${API_URL}add-comment`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async getComment(auth_token,data) {
		const url = `${API_URL}get-comments`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async markRead(auth_token,data) {
		const url = `${API_URL}mark-read`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}

	async updateChat(auth_token,data=null){
		const url = `${API_URL}update-chat`;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+auth_token+'',
		};
		let formData = data;
		return axios({
			url:url,
			method: 'POST',
			data: formData,
			headers: headers
		}).then(function(response){
			return response;
		}).catch(function(error){
			return error.response;
		});
	}
}
export default WAServices;